const Location: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M10.0007 1.6748C6.78732 1.6748 4.17383 4.28992 4.17383 7.50326C4.17383 11.2391 9.14608 17.3076 9.35775 17.5635L10.0007 18.3431L10.6436 17.5635C10.8552 17.3068 15.8275 11.2391 15.8275 7.50326C15.8275 4.28909 13.214 1.6748 10.0007 1.6748ZM10.0007 3.34147C12.2948 3.34147 14.1608 5.20909 14.1608 7.50326C14.1608 9.75742 11.5657 13.6343 10.0007 15.6885C8.43565 13.636 5.84049 9.76076 5.84049 7.50326C5.84049 5.20909 7.70648 3.34147 10.0007 3.34147ZM10.0007 5.41667C8.84982 5.41667 7.91732 6.34917 7.91732 7.5C7.91732 8.65083 8.84982 9.58333 10.0007 9.58333C11.1515 9.58333 12.084 8.65083 12.084 7.5C12.084 6.34917 11.1515 5.41667 10.0007 5.41667Z"
      />
    </svg>
  );
};

export default Location;
